import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";
import AccountCircle from "../other-icons/AccountCircle";
import ArrowRight from "../other-icons/ArrowRight";
import { Link } from "@quintype/components";
import { pushEventToDataLayer } from "../../helper/datalayer-utils";
import "./index.m.css";

const AccountBtn = ({ onAccountHandler, signinHandler: customSigninHandler }) => {
  const isUserLogin = useSelector((state) => get(state, ["isLogin"], false));
  const ssoEndpoint = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "sso_endpoint"], null)
  );
  const [redirectURL, setRedirectUrl] = useState("");

  useEffect(() => {
    setRedirectUrl(window.location.href);
  }, []);

  const signinHandler = () => {
    if (customSigninHandler) {
      customSigninHandler();
      return;
    }
    if (window?.dataLayer) pushEventToDataLayer("SSO_Page_Open");
    if (typeof sessionStorage !== "undefined") {
      sessionStorage.setItem("sso_login_initiated_source", "header_button");
    }
    window.location.href = `${ssoEndpoint}/auth?redirectUrl=${redirectURL}`;
  };

  const handleClick = (e) => {
    if (isUserLogin) {
      // Let Link handle the navigation
      return;
    } else {
      e.preventDefault();
      signinHandler();
    }
  };

  const content = (
    <div styleName="account-btn" onClick={handleClick}>
      <div styleName="icon-wrapper">
        {!isUserLogin && (
          <span styleName="arrow-overlay">
            <ArrowRight />
          </span>
        )}
        <AccountCircle color="#FFF" />
      </div>
    </div>
  );

  if (isUserLogin) {
    return <Link href="/profile">{content}</Link>;
  }
  return content;
};

export default AccountBtn;
